import { capitalize } from 'utils/capitalize'

interface IFormatCityStateProps {
  city?: string
  stateCode?: string
}

const formatCityState = (facility?: IFormatCityStateProps): string | undefined => {
  const city = capitalize(facility?.city)
  const state = facility?.stateCode
  return city && state ? `${city}, ${state}` : undefined
}

export default formatCityState
